import { createSlice } from "@reduxjs/toolkit";
export const notificationInitialState = {
    notification: {
        uuid: "",
    },
};
export const notificationSlice = createSlice({
    name: "notification",
    initialState: notificationInitialState,
    reducers: {
        showNotification: (_state, action) => {
            return {
                ...action.payload,
            };
        },
        clearNotification: () => {
            return notificationInitialState;
        },
    },
});
export const { showNotification, clearNotification } = notificationSlice.actions;
export const notificationReducer = notificationSlice.reducer;
